import {
  WhoWeServeSectionWrapper,
  InnerGapper,
  OuterGapper,
  SectionDescription,
  ButtonWrapper,
} from './styles';
import { WHO_WE_SERVE_CONTENT } from './constants';
import { SectionHeading } from '../../styles';
import CTAButton from '../../../../../ui/ctaButton';
import { openSimplePracticeConsultation } from '../../../../../utils/simplePractice';

const WhoWeServeSection = () => {
  const handleBookConsultation = () => {
    openSimplePracticeConsultation();
  };
  return (
    <WhoWeServeSectionWrapper>
      <OuterGapper>
        <InnerGapper>
          <SectionHeading>{WHO_WE_SERVE_CONTENT.title}</SectionHeading>
          <ButtonWrapper>
            <CTAButton
              variant="outlined"
              text={WHO_WE_SERVE_CONTENT.buttonText}
              onClick={handleBookConsultation}
            />
          </ButtonWrapper>
        </InnerGapper>
        <SectionDescription>{WHO_WE_SERVE_CONTENT.description}</SectionDescription>
      </OuterGapper>
    </WhoWeServeSectionWrapper>
  );
};

export default WhoWeServeSection;
